import { Serializer } from "../resource/serializer.interface";
import { ContactPreference } from "./contact-preference.model";

export class ContactPreferenceSerializer implements Serializer {

  fromJson(json: any): ContactPreference {
    const contactPreference = new ContactPreference();
    contactPreference.id = json.id;
    contactPreference.masterPreferenceId = json.masterPreference_Id;
    contactPreference.value = json.value;
    contactPreference.emailAddress = json.email_address;
    contactPreference.channels = json.channels;
    contactPreference.frequencies = json.frequencies;
    contactPreference.createdAt = json.created_at;
    contactPreference.updatedAt = json.updated_at;
    contactPreference.tenantId = json.tenant_id;
    contactPreference.systemType = json.system_type;
    contactPreference.system = json.system;
    contactPreference.systemId = json.system_id;
    contactPreference.systemRecordId = json.system_record_id;
    contactPreference.systemRecordType = json.system_record_type;
    contactPreference.source = json.source;
    return contactPreference;
  }

  toJson(contactPreference: ContactPreference): any {
    return {
      id: contactPreference.id,
      masterPreference_Id: contactPreference.masterPreferenceId,
      value: contactPreference.value,
      email_address: contactPreference.emailAddress,
      channels: contactPreference.channels,
      frequencies: contactPreference.frequencies,
      created_at: contactPreference.createdAt,
      updated_at: contactPreference.updatedAt,
      tenant_id: contactPreference.tenantId,
      system_type: contactPreference.systemType,
      system: contactPreference.system,
      system_id: contactPreference.systemId,
      system_record_id: contactPreference.systemRecordId,
      system_record_type: contactPreference.systemRecordType,
      source: contactPreference.source
    };
  }
}
